export default {

    //Requires Service Name {?name=Windows Service Name}
    winService: "command/winService", 
    winServiceList: "command/winServiceList", //Not this one
    startWinService: "command/startWinService",
    stopWinService: "command/stopWinService"

    //TODO: Add more

};